// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3qXn3","colMin":"styles_colMin__3A5l2","colCheckbox":"styles_colCheckbox__1wHPf"};